(function ($) {
  var elementorHookRegistered = false;
  var widgetSelector = '[data-listing-actualites]';

  function getListingActualitesWrappers($scope) {
    if ($scope.is(widgetSelector)) {
      return $scope;
    }

    return $scope.find(widgetSelector);
  }

  function initListingActualites($scope) {
    getListingActualitesWrappers($scope).each(function () {
      var $wrapper = $(this);

      if ($wrapper.data('listingActualitesInitialized')) {
        return;
      }

      $wrapper.data('listingActualitesInitialized', true);

      var xhr;
      var page = 1;
      var loading = false;
      var endpoint = $wrapper.attr('data-listing-actualites-endpoint') || '/wp-json/penega/v1/actualites';
      var $container = $wrapper.find('[data-listing-actualites-items]').first();
      var $loadMore = $wrapper.find('[data-listing-actualites-load-more]').first();

      function getSelectedTerms() {
        var val = $wrapper.find('.terms input[type="radio"]:checked').val();

        return val ? [parseInt(val, 10)] : [];
      }

      function setLoadingState(reset) {
        if (reset) {
          page = 1;
          $container.html('<div class="loading"></div>');
          return;
        }

        $container.append('<div class="loading"></div>');
      }

      function loadPosts(reset) {
        if (loading) {
          return;
        }

        loading = true;
        setLoadingState(reset);

        if (xhr) {
          xhr.abort();
        }

        xhr = $.ajax({
          url: endpoint,
          method: 'GET',
          data: {
            type: 'post',
            page: page,
            categories: getSelectedTerms()
          }
        }).done(function (res) {
          $container.find('.loading').remove();

          if (reset) {
            $container.html(res.html || '<p>Aucun article trouvé.</p>');
          } else {
            $container.append(res.html || '');
          }

          if (!res.has_more) {
            $loadMore.hide();
          } else {
            $loadMore.show();
            page++;
          }
        }).fail(function () {
          $container.find('.loading').remove();
        }).always(function () {
          loading = false;
          xhr = null;
        });
      }

      loadPosts(true);

      $wrapper.find('.terms input').on('change.listingActualites', function () {
        if ($(this).closest('li').hasClass('show-all')) {
          $wrapper.find('.terms input').not(this).prop('checked', false);
        } else {
          $wrapper.find('.terms input').not(this).prop('checked', false);
          $wrapper.find('.show-all input').prop('checked', false);
        }

        if ($wrapper.find('.terms input:checked').length === 0) {
          $wrapper.find('.show-all input').prop('checked', true);
        }

        loadPosts(true);
      });

      $loadMore.on('click.listingActualites', function (e) {
        e.preventDefault();
        e.stopImmediatePropagation();
        loadPosts(false);
      });
    });
  }

  function registerElementorHook() {
    if (
      elementorHookRegistered ||
      !window.elementorFrontend ||
      !window.elementorFrontend.hooks
    ) {
      return;
    }

    elementorHookRegistered = true;

    window.elementorFrontend.hooks.addAction(
      'frontend/element_ready/listing-actualites.default',
      initListingActualites
    );
  }

  $(window).on('elementor/frontend/init', registerElementorHook);

  $(function () {
    registerElementorHook();
    initListingActualites($(document));
  });
})(jQuery);
